import { useCheckout } from "../lib/queries.ts";
import { buyLabel, type PlanLike } from "../lib/plan.ts";
import { cn } from "../lib/utils.ts";
import { Button } from "./ui/button.tsx";
import { useToast } from "./ui/toast.tsx";

/** "Buy at the founding price, $1.99": opens Polar's checkout for the whole household. */
export function BuyButton({
  offer,
  placement,
  className,
}: {
  offer: NonNullable<PlanLike["offer"]>;
  placement: "settings" | "log";
  className?: string;
}) {
  const checkout = useCheckout();
  const toast = useToast();
  // Stays busy after success: the browser is already leaving for Polar.
  const opening = checkout.isPending || checkout.isSuccess;
  return (
    <Button
      variant="primary"
      className={cn("w-full", className)}
      disabled={opening}
      data-ph-capture-attribute-placement={placement}
      onClick={() => checkout.mutate(placement, { onError: (err) => toast.show(err.message) })}
    >
      {opening ? "Opening checkout…" : buyLabel(offer)}
    </Button>
  );
}
